/**
 * useChannels - React Query hooks for workspace channels.
 */

import { useQuery } from '@tanstack/react-query'
import {
  getChannels,
  getAllChannelRequirements,
  type Channel,
  type ChannelRequirement,
} from '@/lib/api/channels'

export function useChannels() {
  return useQuery<Channel[]>({
    queryKey: ['channels'],
    queryFn: async () => {
      const res = await getChannels()
      return res.channels || []
    },
  })
}

export function useAllChannelRequirements() {
  return useQuery<ChannelRequirement[]>({
    queryKey: ['channel-requirements', 'all'],
    queryFn: async () => {
      const res = await getAllChannelRequirements()
      return res.requirements || []
    },
  })
}
